module.exports = __webpack_public_path__ + "img/silver4.c47d5c7d.png";